import { SelectOption } from '../../../types/sale/creditNote/CreditNoteSaleLookup';

export interface CreditNoteLookupOptionDTO {
  id: number;
  label?: string | null;
  name?: string | null;
}

/** Compatibilidad con respuestas nuevas (`label`) y registros anteriores (`name`). */
export const mapCreditNoteLookupOption = (
  item: CreditNoteLookupOptionDTO,
): SelectOption => ({
  id: item.id,
  name: String(item.label ?? item.name ?? `Venta #${item.id}`).trim(),
});
